import "./utilities_namespace.js";

// Locale-independent YYYY-MM-DD for machine-facing date strings (URL params,
// cache keys, element ids). moment's `format` output is localized — under `ar`
// its postformat rewrites digits to Arabic-Indic numerals, which the server's
// Date.parse rejects and ISO string comparisons miss — so anything not meant
// for human eyes must format through the `en` locale.
window.Sparkle.Utilities.isoDate = function (momentDate) {
  return momentDate.clone().locale("en").format("YYYY-MM-DD");
};
